import { useTranslation } from "../i18n";
import { CT, FS, Z } from "../lib/tokens";

// 77 §4a (RULED, Laurent 2026-08-11 A.3) — A TENANT ON THE LENIENT FLOOR SAYS SO,
// "where somebody will see it — not only in a JSON file on the box".
//
// ONE COMPONENT, BOTH SURFACES. The login screen needs it because a person is
// about to type real client data into a demo tenant and must be told BEFORE he
// signs in; the app shell needs it because he spends the rest of the day in
// there. Two copies of this markup would be two chances to change one and not
// the other, so it is a component that takes a position rather than two blocks
// that look alike.
//
// THE WORDS ARE LAURENT'S, VERBATIM, and the fallbacks below are the English of
// the three rows seeded into `demo.banner` — they are the same sentence, so a
// box that has not been seeded still says the right thing rather than printing
// a key.
//
// THE FLAG IS DERIVED, NEVER STORED BESIDE THE FLOOR: the server answers
// `demo` on /api/auth/config from lib/authPolicy.js resolve().demo, which reads
// the floor itself. A tenant therefore cannot be lenient without saying so, or
// say so without being lenient.
export default function DemoBanner({
  // "fixed" for the app shell (it must survive scrolling), "static" for the
  // login card, which is centred and has nothing to scroll past.
  position = "fixed",
  // Stacks under the simulation banner when both are up — that one is 0.
  top = 0,
}: {
  position?: "fixed" | "static";
  top?: number;
}) {
  const { t } = useTranslation();
  const text = t("demo.banner", { fallback: "DEMO, do not register real data" });

  return (
    <div
      role="status"
      style={{
        ...(position === "fixed"
          ? { position: "fixed", top, left: 0, right: 0, zIndex: Z.topMenu }
          : { position: "static", width: "100%", borderRadius: 6 }),
        padding: "6px 12px",
        background: CT.c_fbbf24,
        color: CT.c_1a1a1a,
        fontSize: FS.s11,
        fontWeight: 700,
        letterSpacing: ".04em",
        textAlign: "center",
        boxShadow: position === "fixed" ? "0 2px 8px rgba(0,0,0,.4)" : "none",
      }}
    >
      {text}
    </div>
  );
}
